<template>
  <b-modal ref="modal" centered hide-footer modal-class="atr-modal" :title="$t('account.report.title', { id: accountId })">
    <p class="atr__hint">{{ $t('account.report.description') }}</p>

    <div class="atr__grid">
      <div class="atr__field">
        <label class="atr__label">{{ $t('account.report.from') }}</label>
        <b-form-datepicker v-model="from" :locale="$i18n.locale" reset-button
                           :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"/>
      </div>
      <div class="atr__field">
        <label class="atr__label">{{ $t('account.report.until') }}</label>
        <b-form-datepicker v-model="until" :locale="$i18n.locale" reset-button
                           :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"/>
      </div>
    </div>

    <div class="atr__field">
      <label class="atr__label">{{ $t('account.report.trades') }}</label>
      <b-form-radio-group v-model="result" class="atr__radios" stacked>
        <b-form-radio value="BOTH">{{ $t('account.report.both') }}</b-form-radio>
        <b-form-radio value="WIN">{{ $t('account.report.winning') }}</b-form-radio>
        <b-form-radio value="LOSS">{{ $t('account.report.losing') }}</b-form-radio>
      </b-form-radio-group>
    </div>

    <div class="atr__footer">
      <b-button variant="outline-secondary" :disabled="downloading != null" @click="$refs.modal.hide()">
        {{ $t('operations.cancel') }}
      </b-button>
      <b-button variant="success" :disabled="downloading != null" @click="download('EXCEL')">
        <b-spinner v-if="downloading === 'EXCEL'" small class="mr-50"/>
        <i v-else class="fa-solid fa-file-excel mr-50"></i>{{ $t('account.report.excel') }}
      </b-button>
      <b-button variant="primary" :disabled="downloading != null" @click="download('PDF')">
        <b-spinner v-if="downloading === 'PDF'" small class="mr-50"/>
        <i v-else class="fa-solid fa-file-pdf mr-50"></i>{{ $t('account.report.pdf') }}
      </b-button>
    </div>
  </b-modal>
</template>

<script>
import { mapActions } from 'vuex';
import mixinNotifications from '@/components/mixin/mixinNotifications';

export default {
  name: 'AccountTradeReportModal',
  mixins: [mixinNotifications],
  props: {
    accountId: {
      type: String,
      default: null
    },
    currency: {
      type: String,
      default: null
    },
    client: {
      type: Object,
      default: null
    },
  },
  data: () => ({
    from: null,
    until: null,
    result: 'BOTH',
    downloading: null,
  }),
  methods: {
    ...mapActions('trade', ['downloadAccountTradeReport']),
    show() {
      this.downloading = null;
      this.$refs.modal.show();
    },
    clientName() {
      if (!this.client) return null;
      return [this.client.firstName, this.client.lastName].filter(Boolean).join(' ') || null;
    },
    async download(exportType) {
      this.downloading = exportType;
      try {
        await this.downloadAccountTradeReport({
          account: this.accountId,
          request: {
            range: { from: this.from || null, until: this.until || null },
            result: this.result,
            exportType,
            clientName: this.clientName(),
            currency: this.currency,
          },
        });
        this.showSuccessNotification(this.$t('account.report.success'));
        this.$refs.modal.hide();
      } catch (err) {
        this.showErrorNotification(this.$t('account.report.error'));
      } finally {
        this.downloading = null;
      }
    },
  },
};
</script>

<style lang="scss">
.atr-modal {
  .atr__hint { font-size: 0.85rem; color: #6e6b7b; margin-bottom: 1rem; }
  .atr__grid { display: grid; grid-template-columns: 1fr 1fr; gap: 0.9rem; margin-bottom: 0.9rem; }
  .atr__field { min-width: 0; margin-bottom: 0.9rem; }
  .atr__label {
    font-size: 0.72rem; font-weight: 700; text-transform: uppercase;
    letter-spacing: 0.03em; color: #6e6b7b; margin-bottom: 0.3rem; display: block;
  }
  .atr__radios .custom-control { margin-bottom: 0.35rem; }
  .atr__footer { display: flex; justify-content: flex-end; gap: 0.6rem; margin-top: 0.4rem; }
  // keep the date label on one line inside the narrow field
  .b-form-datepicker > label.form-control {
    white-space: nowrap; overflow: hidden; text-overflow: ellipsis; height: auto;
  }
  @media (max-width: 575px) { .atr__grid { grid-template-columns: 1fr; } }
}
body.dark-layout .atr-modal {
  .modal-content { background: var(--crm-dark-surface, #232c3e); color: #d0d2d6; }
  .atr__hint, .atr__label { color: #9ba3b5; }
}
</style>
